const testIds = {
  inputName: "input-name",
  inputAmount: "input-amount",
  button: "submit-item",
};

export default testIds;
